

// import React, { useEffect, useState } from "react";
// import { Select, Input, DatePicker, Button, Space } from "antd";
// import { SearchOutlined, ReloadOutlined } from "@ant-design/icons";
// import { useSearchParams } from "react-router-dom";
// import dayjs from "dayjs";

// const { RangePicker } = DatePicker;
// const { Option } = Select;

// const CommonFilter = ({ columns, onFilterChange, setRatingValue }) => {
//   const [searchParams, setSearchParams] = useSearchParams();
//   const searchKey = searchParams.get("search_key");
//   const searchValue = searchParams.get("search_value");
//   const statusParam = searchParams.get("status");
//   const positionParam = searchParams.get("position");
//   // const ratingParams = searchParams.get("rating");
//   const [selectedColumn, setSelectedColumn] = useState("all");
//   const [filters, setFilters] = useState({});

 

//   useEffect(() => {
//     let activeKey = "all";
//     let parsedValue = "";

   
  
//     if (statusParam !== null && statusParam !== "") {
//       activeKey = "status";
//       parsedValue = Number(statusParam);
//     } 
//     // else if(ratingParams !== null && ratingParams !== "")  {
//     //   activeKey = "rating";
//     //   parsedValue = Number(ratingParams);
//     // }
//     else if (positionParam !== null && positionParam !== "") {
//       activeKey = "position";
//       parsedValue = Number(positionParam);
//     } else if (searchKey && searchKey !== "all") {
//       activeKey = searchKey;
//       const column = columns.find((col) => col.dataIndex === searchKey);
//       if (column?.type === "date") {
//         parsedValue = searchValue ? searchValue.split(",") : [];
//       } else {
//         parsedValue = searchValue ?? "";
//       }
//     }
   
//     setSelectedColumn(activeKey);
//     setFilters({ [activeKey]: parsedValue });

//     onFilterChange(activeKey, parsedValue);
//   }, []);

//   const handleColumnChange = (value) => {
//     setSelectedColumn(value);
//     setFilters({ [value]: "" });

  

//     setSearchParams((prev) => {
//       const updated = new URLSearchParams(prev);
//       if (value === "status") {
//         updated.set("status", "");
//         updated.delete("position");
//         updated.delete("search_key");
//         updated.delete("search_value");
//       } else if (value === "position") {
//         updated.set("from_date", value?.[0] ?? "");
//         updated.set("to_date", value?.[1] ?? "");
//         updated.delete("search_value");
//         updated.delete("status");
//         updated.delete("position");
//       } else if (value === "date") {
//         updated.set("position", "");
//         updated.delete("status");
//         updated.delete("search_key");
//         updated.delete("search_value");

//       }
//       // else if (value === "rating"){
//       //   updated.set("rating", "");
//       //   updated.delete("position");
//       //   updated.delete("status");
//       //   updated.delete("search_key");
//       //   updated.delete("search_value");
//       // } 
//       else {
//         updated.set("search_key", value);
//         updated.set("search_value", "");
//         updated.delete("status");
//         updated.delete("position");
//       }
//       return updated;
//     });

//     onFilterChange(value, "");
//   };

//   const handleChange = (key, value) => {
//     const column = columns.find((col) => col.dataIndex === key);
//     const columnType = column?.type;

//     let finalValue;
//     if (columnType === "status" || columnType === "select" || key === "rating") {
//       finalValue =
//         value !== null && value !== undefined && value !== ""
//           ? Number(value)
//           : null;
//     } else {
//       finalValue = value;
//     }
   
//     setFilters((prev) => ({ ...prev, [key]: finalValue }));



//     setSearchParams((prev) => {
     
//       const updated = new URLSearchParams(prev);
     
//       if (key === "status") {
//         updated.set("status", finalValue ?? "");
//         updated.delete("search_key");
//         updated.delete("search_value");
//       } else {
//         updated.set("search_key", key);
//         updated.set(
//           "search_value",
//           Array.isArray(value) ? value.join(",") : value ?? ""
//         );
//         updated.delete("status");
//       }
//       if (key === "status") {
//         updated.set("status", finalValue ?? "");
//         updated.delete("position");
//         updated.delete("search_key");
//         updated.delete("search_value");
//       } else if (key === "position") {
//         updated.set("position", finalValue ?? "");
//         updated.delete("status");
//         updated.delete("search_key");
//         updated.delete("search_value");
//       } else if (columnType === "date") {
//         updated.set("from_date", value?.[0] ?? "");
//         updated.set("to_date", value?.[1] ?? "");
//         updated.delete("search_key");
//         updated.delete("search_value");
//         updated.delete("status");
//         updated.delete("position");
//       } else {
//         updated.set("search_key", key);
//         updated.set(
//           "search_value",
//           Array.isArray(value) ? value.join(",") : value ?? ""
//         );
//         updated.delete("status");
//         updated.delete("position");
//       }
//       return updated;
//     });

//     if (columnType === "date") {
//       onFilterChange(key, {
//         from_date: value?.[0],
//         to_date: value?.[1],
//       });
//     }
//     // else if (columnType === "rating") {
//     //   onFilterChange(key, value);
//     // }
//      else {
//       onFilterChange(key, finalValue);
//     }
//   };

//   const handleReset = () => {
//     setSelectedColumn("all");
//     setFilters({ all: "" });

//     setSearchParams((prev) => {
//       const updated = new URLSearchParams(prev);
//       updated.set("search_key", "all");
//       updated.set("search_value", "");
//       updated.delete("status");
//       return updated;
//     });

//     onFilterChange("all", "", true);
//   };

//   const selectedColumnData = columns.find(
//     (col) => col.dataIndex === selectedColumn
//   );

//   // const handleRating = (key, finalValue) => {
//   //   console.log([key], finalValue, "shksdhjd")
   
//   //   setSelectedColumn("rating");
//   //   // setFilters((prev) => ({ ...prev, [key]: finalValue }));
//   //   setSearchParams((prev) => {
//   //     const updated = new URLSearchParams(prev);
//   //     updated.set("rating", finalValue ?? "");
//   //     updated.delete("search_key");
//   //     updated.delete("search_value");
//   //     return updated;
//   //   })
//   //   onFilterChange([key], finalValue)
//   // }

 

//   // console.log(selectedColumn, "snnkdkndf"
//   // )

//   return (
//     <Space className="customFilter" wrap>
//       <Select
//         value={selectedColumn}
//         onChange={handleColumnChange}
//         style={{ width: 200 }}
//       >
//         <Option value="all">All</Option>
//         {columns
//           .filter((col) => col.type)
//           .map((col) => (
//             <Option key={col.dataIndex} value={col.dataIndex}>
//               {col.placeName ? col.placeName : col.title}
//             </Option>
//           ))}
//       </Select>

//       {/* { selectedColumn === "rating" ?
//         <input type="Search" placeholder="Star Rating"  onChange={(e) =>  handleChange("rating" ,e.target.value)} /> : */}
//       {  
      
//       // selectedColumn === "rating" ?  <Input
//       //     placeholder="Search rating all columns"
//       //     prefix={<SearchOutlined />}
//       //     value={filters.rating || ""}
//       //     onChange={(e) => handleChange("rating", e.target.value)}
//       //     allowClear
//       //     style={{ width: 250 }}
//       //   /> :  
        
//         selectedColumn === "all"   ? (
//         <Input
//           placeholder="Search across all columns"
//           prefix={<SearchOutlined />}
//           value={filters.all || ""}
//           onChange={(e) => handleChange("all", e.target.value)}
//           allowClear
//           style={{ width: 250 }}
//         />
//       ) : selectedColumnData?.type === "search" ? (
//         <Input
//           placeholder={`Search ${selectedColumnData.title}`}
//           prefix={<SearchOutlined />}
//           value={filters[selectedColumn] || ""}
//           onChange={(e) => handleChange(selectedColumn, e.target.value)}
//           allowClear
//           style={{ width: 250 }}
//         />
//       ) : selectedColumnData?.type === "select" ||
//         selectedColumnData?.type === "status" ? (
//         <Select
//           placeholder={`Filter ${selectedColumnData.title}`}
//           value={filters[selectedColumn] ?? null}
//           onChange={(value) => handleChange(selectedColumn, value)}
//           style={{ width: 180 }}
//           allowClear
//         >
//           {selectedColumnData.options?.map((option) => (
//             <Option key={option.value} value={option.value}>
//               {option.label}
//             </Option>
//           ))}
//         </Select>
//       ) : selectedColumnData?.type === "date" ? (
//         <RangePicker
//           format="YYYY/MM/DD"
//           value={
//             filters[selectedColumn]
//               ? [
//                   filters[selectedColumn][0] &&
//                     dayjs(filters[selectedColumn][0]),
//                   filters[selectedColumn][1] &&
//                     dayjs(filters[selectedColumn][1]),
//                 ]
//               : null
//           }
//           onChange={(dates, dateStrings) =>
//             handleChange(selectedColumn, dateStrings)
//           }
//           style={{ width: 280 }}
//         />
//       ) : null}

//       <Button icon={<ReloadOutlined />} onClick={handleReset}>
//         Reset
//       </Button>
//     </Space>
//   );
// };

// export default CommonFilter;









import React, { useEffect, useState } from "react";
import { Select, Input, DatePicker, Button, Space } from "antd";
import { SearchOutlined, ReloadOutlined } from "@ant-design/icons";
import { useSearchParams } from "react-router-dom";
import dayjs from "dayjs";

const { RangePicker } = DatePicker;
const { Option } = Select;

const CommonFilter = ({ columns, onFilterChange }) => {
  const [searchParams, setSearchParams] = useSearchParams();
  const searchKey = searchParams.get("search_key");
  const searchValue = searchParams.get("search_value");
  const statusParam = searchParams.get("status");
  const positionParam = searchParams.get("position");
  const [selectedColumn, setSelectedColumn] = useState("all");
  const [filters, setFilters] = useState({});

  useEffect(() => {
    let activeKey = "all";
    let parsedValue = "";

    if (statusParam !== null && statusParam !== "") {
      activeKey = "status";
      parsedValue = Number(statusParam);
    } else if (positionParam !== null && positionParam !== "") {
      activeKey = "position";
      parsedValue = Number(positionParam);
    } else if (searchKey && searchKey !== "all") {
      activeKey = searchKey;
      const column = columns.find((col) => col.dataIndex === searchKey);
      if (column?.type === "date") {
        parsedValue = searchValue ? searchValue.split(",") : [];
      } else {
        parsedValue = searchValue ?? "";
      }
    }

    setSelectedColumn(activeKey);
    setFilters({ [activeKey]: parsedValue });

    onFilterChange(activeKey, parsedValue);
  }, []);

  const handleColumnChange = (value) => {
    setSelectedColumn(value);
    setFilters({ [value]: "" });

    setSearchParams((prev) => {
      const updated = new URLSearchParams(prev);
      if (value === "status") {
        updated.set("status", "");
        updated.delete("position");
        updated.delete("search_key");
        updated.delete("search_value");
      } else if (value === "position") {
        updated.set("from_date", value?.[0] ?? "");
        updated.set("to_date", value?.[1] ?? "");
        updated.delete("search_value");
        updated.delete("status");
        updated.delete("position");
      } else if (value === "date") {
        updated.set("position", "");
        updated.delete("status");
        updated.delete("search_key");
        updated.delete("search_value");
      } else if (value === "act_date") {
        updated.set("position", "");
        updated.delete("status");
        updated.delete("search_key");
        updated.delete("search_value");
      } else {
        updated.set("search_key", value);
        updated.set("search_value", "");
        updated.delete("status");
        updated.delete("position");
      }
      return updated;
    });

    onFilterChange(value, "");
  };

  const handleChange = (key, value) => {
    const column = columns.find((col) => col.dataIndex === key);
    const columnType = column?.type;

    let finalValue;
    if (columnType === "status" || columnType === "select") {
      finalValue =
        value !== null && value !== undefined && value !== ""
          ? Number(value)
          : null;
    } else {
      finalValue = value;
    }

    setFilters((prev) => ({ ...prev, [key]: finalValue }));

    setSearchParams((prev) => {
      const updated = new URLSearchParams(prev);
      if (key === "status") {
        updated.set("status", finalValue ?? "");
        updated.delete("search_key");
        updated.delete("search_value");
      } else {
        updated.set("search_key", key);
        updated.set(
          "search_value",
          Array.isArray(value) ? value.join(",") : value ?? ""
        );
        updated.delete("status");
      }
      if (key === "status") {
        updated.set("status", finalValue ?? "");
        updated.delete("position");
        updated.delete("search_key");
        updated.delete("search_value");
      } else if (key === "position") {
        updated.set("position", finalValue ?? "");
        updated.delete("status");
        updated.delete("search_key");
        updated.delete("search_value");
      } else if (columnType === "date") {
        updated.set("from_date", value?.[0] ?? "");
        updated.set("to_date", value?.[1] ?? "");
        updated.delete("search_key");
        updated.delete("search_value");
        updated.delete("status");
        updated.delete("position");
      } else if (columnType === "act_date") {
        updated.set("act_from_date", value?.[0] ?? "");
        updated.set("act_to_date", value?.[1] ?? "");
        updated.delete("search_key");
        updated.delete("search_value");
        updated.delete("status");
        updated.delete("position");
      } else {
        updated.set("search_key", key);
        updated.set(
          "search_value",
          Array.isArray(value) ? value.join(",") : value ?? ""
        );
        updated.delete("status");
        updated.delete("position");
      }
      return updated;
    });

    if (columnType === "date") {
      onFilterChange(key, {
        from_date: value?.[0],
        to_date: value?.[1],
      });
    } else if (columnType === "act_date") {
      onFilterChange(key, {
        act_from_date: value?.[0],
        act_to_date: value?.[1],
      });
    } else {
      onFilterChange(key, finalValue);
    }
  };

  const handleReset = () => {
    setSelectedColumn("all");
    setFilters({ all: "" });

    setSearchParams((prev) => {
      const updated = new URLSearchParams(prev);
      updated.set("search_key", "all");
      updated.set("search_value", "");
      updated.delete("status");
      return updated;
    });

    onFilterChange("all", "", true);
  };

  const selectedColumnData = columns.find(
    (col) => col.dataIndex === selectedColumn
  );

  return (
    <Space className="customFilter" wrap>
      <Select
        value={selectedColumn}
        onChange={handleColumnChange}
        style={{ width: 200 }}
      >
        <Option value="all">All</Option>
        {columns
          .filter((col) => col.type)
          .map((col) => (
            <Option key={col.dataIndex} value={col.dataIndex}>
              {col.placeName ? col.placeName : col.title}
            </Option>
          ))}
      </Select>

      {selectedColumn === "all" ? (
        <Input
          placeholder="Search across all columns"
          prefix={<SearchOutlined />}
          value={filters.all || ""}
          onChange={(e) => handleChange("all", e.target.value)}
          allowClear
          style={{ width: 250 }}
        />
      ) : selectedColumnData?.type === "search" ? (
        <Input
          placeholder={`Search ${selectedColumnData.title}`}
          prefix={<SearchOutlined />}
          value={filters[selectedColumn] || ""}
          onChange={(e) => handleChange(selectedColumn, e.target.value)}
          allowClear
          style={{ width: 250 }}
        />
      ) : selectedColumnData?.type === "select" ||
        selectedColumnData?.type === "status" ? (
        <Select
          placeholder={`Filter ${selectedColumnData.title}`}
          value={filters[selectedColumn] ?? null}
          onChange={(value) => handleChange(selectedColumn, value)}
          style={{ width: 180 }}
          allowClear
        >
          {selectedColumnData.options?.map((option) => (
            <Option key={option.value} value={option.value}>
              {option.label}
            </Option>
          ))}
        </Select>
      ) : selectedColumnData?.type === "date" || "act_date" ? (
        <RangePicker
          format="YYYY-MM-DD"
          value={
            filters[selectedColumn]
              ? [
                  filters[selectedColumn][0] &&
                    dayjs(filters[selectedColumn][0]),
                  filters[selectedColumn][1] &&
                    dayjs(filters[selectedColumn][1]),
                ]
              : null
          }
          onChange={(dates, dateStrings) =>
            handleChange(selectedColumn, dateStrings)
          }
          style={{ width: 250 }}
        />
      ) : null}

      <Button icon={<ReloadOutlined />} onClick={handleReset}>
        Reset
      </Button>
    </Space>
  );
};

export default CommonFilter;


